enum TypeAccident {
  TRAJET = "TRAJET",
  TRAVAIL = "TRAVAIL",
}

export default TypeAccident;
